module.exports = __webpack_public_path__ + "img/icon-payment-card.a293f53e.svg";